import styles from './Menu.module.css';
import logo from "../../imagens/logonavbar2_plain.svg";

function Menu({ onFilterClick }) {
  const items = [
    { label: "Menu", value: "initialPage", isPrimary: true },
    { label: "Produção", value: "natureProduction" },
    { label: "Condições Gerais", value: "generalCondition" },
    { label: "Saúde", value: "health" },
    { label: "Escolaridade", value: "education" },
    { label: "Aspectos Socioeconômicos", value: "social" },
    { label: "Agroturismo", value: "agritourism" },
    { label: "Características Ambientais e Agrotóxicos", value: "ambiental" },
    { label: "Produtos Fabricados", value: "fabricados" },
    { label: "Infraestrutura", value: "infra" },
    { label: "Gestão / Mão de Obra", value: "obra" },
  ];

  return (
    <div className={styles.menu}>
      <img src={logo} alt="GENTE" className={styles.logo} />
      {items.map(({ label, value }, index) => (
        <p
          key={value}
          onClick={() => onFilterClick(value)}
          className={styles.item}
        >
          {label}
        </p>
      ))}
    </div>
  );
}

export default Menu;
